export default "__VITE_ASSET__CD9DE9Ot__"